import type { ProfileResource } from "@medplum/core";
import { usePermissions } from "@repo/auth";
import type { ScheduleDto } from "@repo/data-store";
import { practitionerDomainIdFromProfile } from "@/shared/hooks/use-current-practitioner";

export function useSchedulePermissions(schedule: ScheduleDto | null | undefined, profile: ProfileResource | undefined) {
  const { canRead, canWrite, isAdmin } = usePermissions();

  const actorRef = schedule ? `${schedule.actor.type}/${schedule.actor.id}` : null;
  const practitionerId = practitionerDomainIdFromProfile(profile);
  const userRef = practitionerId ? `Practitioner/${practitionerId}` : null;
  const isOwner = actorRef === userRef;

  const actorType = schedule?.actor.type;
  const isLocationOrDevice = actorType === "Location" || actorType === "Device";

  const canWriteResult = isAdmin || (!isLocationOrDevice && isOwner && canWrite("Schedule"));

  return {
    canRead: canRead("Schedule"),
    // Can write if: admin OR (owns practitioner schedule AND has write permission)
    // Location/Device schedules require admin
    canWrite: canWriteResult,
    isOwner,
    isAdmin,
    isLocationOrDevice,
  };
}
